import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../../apiConfig";
import { useNavigate } from "react-router-dom";

const PanFind = () => {   //add by jinal
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		aadhaarNo: "",
		name: "",
		dateOfBirth: "",
	});
	const [serverError, setServerError] = useState("");
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [errors, setErrors] = useState({ aadhaarNo: "", });

	const [editId, setEditId] = useState(null);

	// Aadhaar validation regex
	const aadhaarRegex = /^[2-9]{1}[0-9]{11}$/;

	// Load existing record if editing
	useEffect(() => {
		const id = localStorage.getItem("panFindId");
		if (id) {
			setEditId(id);
			const authToken = localStorage.getItem("authToken");
			//fetch(`https://apiv2.chakran.in/api/PanFind/GetPanFindById/${id}`, {
			fetch(`${API_BASE_URL}/PanFind/GetPanFindById/${id}`, {
				headers: { Authorization: `Bearer ${authToken}` },
			})
				.then((res) => res.json())
				.then((data) => {
					setFormData({
						aadhaarNo: data.aadhaarNo,
						name: data.name,
						dateOfBirth: data.dateOfBirth
							? new Date(data.dateOfBirth).toISOString().split("T")[0]
							: "",
					});
				})
				.catch((err) => console.error("Error loading record:", err));
		}
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;


		if (name === "aadhaarNo") {
			const digitsOnly = value.replace(/\D/g, "");
			if (digitsOnly.length > 12) return; // Prevent more than 12 digits

			let errorMsg = "";
			if (!digitsOnly) {
				errorMsg = "Aadhaar No is required.";
			} else if (digitsOnly.length < 12) {
				errorMsg = "Aadhaar No must be 12 digits.";
			} else if (!/^[2-9]{1}[0-9]{11}$/.test(digitsOnly)) {
				errorMsg = "Enter valid Aadhaar number (first digit 2-9, total 12 digits).";
			}
			setErrors((prev) => ({ ...prev, aadhaarNo: errorMsg }));
			setFormData((prev) => ({ ...prev, [name]: digitsOnly }));
			return;
		}

		setFormData((prev) => ({ ...prev, [name]: value }));
	};


	const handleStay = () => {
		setShowConfirmModal(false);
	};

	const handleFormSubmit = (e) => {
		e.preventDefault();
		setServerError("");

		// Final validation before showing modal
		if (errors.aadhaarNo || !formData.aadhaarNo) {
			setServerError("Please enter a valid Aadhaar No.");
			return;
		}
		if (errors.name || !formData.name) {
			setServerError("Please enter a valid Name.");
			return;
		}

		setShowConfirmModal(true);
	};
	const handleConfirm = async () => {
		setShowConfirmModal(false);

		const formattedDate = new Date(formData.dateOfBirth).toLocaleDateString("en-GB");
		const panFindDto = {
			AadhaarNo: formData.aadhaarNo,
			Name: formData.name,
			DateOfBirth: formattedDate,
		};
		const authToken = localStorage.getItem("authToken");

		try {
			// const url = editId
			// 	? 'https://apiv2.chakran.in/api/PanFind/UpdatePanFind/${editId}'
			// 	: "https://apiv2.chakran.in/api/PanFind/PanFind";

			const url = editId
				? `${API_BASE_URL}/PanFind/UpdatePanFind/${editId}`
				: `${API_BASE_URL}/PanFind/PanFind`;

			const method = editId ? "PUT" : "POST";

			const response = await fetch(url, {
				method,
				headers: {
					Authorization: `Bearer ${authToken}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(panFindDto),
			});

			if (response.ok) {
				const data = await response.json();
				alert(editId ? "Record updated successfully!" : "Record saved successfully!");
				localStorage.removeItem("panFindId");
				window.dispatchEvent(new Event("balanceUpdated"));
				navigate("/dashboard/pan-find-report");
			} else {
				const error = await response.json();
				alert(`Error: ${error.message}`);
			}
		} catch (err) {
			setServerError(err.message);
			alert("An error occurred while submitting data.");
		}
	};
	//   try {
	//     const response = await fetch("https://apiv2.chakran.in/api/PanFind/PanFind", {
	//       method: "POST",
	//       headers: {
	//         Authorization: `Bearer ${authToken}`,
	//         "Content-Type": "application/json",
	//       },
	//       body: JSON.stringify(panFindDto),
	//     });

	//     if (response.ok) {
	//       const data = await response.json();
	//       alert(`Data saved successfully!`);
	//       window.dispatchEvent(new Event("balanceUpdated"));
	//       setFormData({ aadhaarNo: "", name: "", dateOfBirth: "" });
	//     } else {
	//       const error = await response.json();
	//       alert(`Error: ${error.message}`);
	//     }
	//   } catch (err) {
	//     setServerError(err.message);
	//     alert("An error occurred while submitting data.");
	//   }
	// };		
	return (
		<div className="kids-avenue-font">
			<form onSubmit={handleFormSubmit}>
				<div className="card card-default">
					<div className="card-body">
						<div className="row">
							<div className="form-group col-md-3">
								<label for="aadharNo">Aadhar No <span style={{ color: "red" }}>*</span></label>
								<input
									type="text"
									className="form-control"
									id="AadharNo"
									name="aadhaarNo"
									value={formData.aadhaarNo}
									onChange={handleChange}
									maxLength={12}
								/>
								{errors.aadhaarNo && <small style={{ color: "red" }}>{errors.aadhaarNo}</small>}
							</div>
							<div className="form-group col-md-3">
								<label for="AoType">Name as per Aadhar</label>
								<input
									type="text"
									className="form-control"
									id="NameAadhar"
									name="name"
									value={formData.name}
									onChange={handleChange}
								/>

							</div>
							<div className="form-group col-md-3">
								<label for="RangeCode">Date Of Birth (DOB)</label>
								<div className="input-group mb-3">
									<input
										type="date"
										className="form-control"
										name="dateOfBirth"
										value={formData.dateOfBirth}
										onChange={handleChange}
									/>
								</div>
								<p style={{ fontSize: '90%' }}>ex. 99/99/9999</p>
							</div>
						</div>
						<div>

							<div className="form-footer pt-4 text-center">
								{!editId && <p>Note: Form Submition Charges Rs.25</p>}
								<button type="submit" className="btn btn-primary btn-pill">{editId ? "Update" : "Submit"}</button>
							</div>

						</div>
					</div>
				</div>
				{/* 🔴 Display server error if it exists */}
				{serverError && <div className="alert alert-danger">{serverError}</div>}
			</form>
			{showConfirmModal && (
				<div className="modal-backdrop" style={{
					position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
					background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
				}}>
					<div style={{
						background: "#fff", padding: 24, borderRadius: 8, minWidth: 300, textAlign: "center"
					}}>
						<h5>Do you want to submit?</h5>
						<p>Press Confirm to submit or Stay to remain on this page.</p>
						<button className="btn btn-secondary mr-2" onClick={handleStay}>Stay</button>
						<button className="btn btn-primary" onClick={handleConfirm}>Confirm</button>
					</div>
				</div>
			)}


		</div>

	);
};
export default PanFind;